import { defineStore } from 'pinia';

export const useTranslationsStore = defineStore({
    id: 'translations',
    state: () => ({
        areaId: document.documentElement.getAttribute('data-area-id'),
        translations: null,
        isLoading: false
    }),
    getters: {
        getTranslation: state => key => state.translations.find(x => x.Key == key) ? state.translations.find(x => x.Key == key) : { Key: key, DefaultValue: key, Value: `Translation does not exist for key "${key}".` },
        getTranslations: state => keys => {
            const translations = [];

            keys.forEach(key => {
                translations.push(state.translations.find(x => x.Key == key) ? state.translations.find(x => x.Key == key) : { Key, DefaultValue: key, Value: `Translation does not exist for key "${key}".` });
            });

            return translations;
        },
        getTranslationsByCategory: state => key => state.translations.filter(x => x.Key.includes(`Translate.${key}`))
    },
    actions: {
        async fetchTranslations() {
            if (this.translations === null) {
                await fetch(`/dwapi/translations/area/${this.areaId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.translations = data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
            } else {
                this.isLoading = false;
            }
        }
    }
});
